import { CherryPayApi } from "../../api/models";

interface ValidateScheduleOptions {
  riskLevel: CherryPayApi.CherryPassNotificationScheduleReviewRiskLevel | null;
  isReviewingMessage: boolean;
  message: string;
  showErrorToast: (message: string) => void;
  showConfirmationDialog: (
    title: string,
    message: string,
    confirmText: string,
    cancelText: string
  ) => Promise<{ ok: boolean }>;
}

/**
 * Validates if a notification can be scheduled based on its risk rating.
 * Returns true if scheduling should proceed, false otherwise.
 */
export const validateNotificationSchedule = async ({
  riskLevel,
  isReviewingMessage,
  message,
  showErrorToast,
  showConfirmationDialog,
}: ValidateScheduleOptions): Promise<boolean> => {
  // If message is empty, proceed with normal validation
  if (!message || message.trim() === "") {
    return true;
  }

  // If still reviewing the message, wait until it's done
  if (isReviewingMessage) {
    showErrorToast("Please wait while we review your message...");
    return false;
  }

  // Check risk level
  if (riskLevel === "HighRisk") {
    showErrorToast(
      "Notifications rated 'High Risk' cannot be scheduled. Please update your message to reduce compliance risk."
    );
    return false;
  }

  if (riskLevel === "MediumRisk") {
    // Show confirmation dialog
    const result = await showConfirmationDialog(
      "This message is rated 'Review Required'",
      "Are you sure you want to schedule without revising?",
      "Confirm",
      "Cancel"
    );

    return result.ok;
  }

  // No risk or low risk - proceed
  return true;
};
